const Pages = {
    exemplo: {
        title: 'Exemplos',
        legenda: 'Lista com os exemplos cadastrados',
        url: {
            list: '/cadastro/exemplo',
            new: '/cadastro/exemplo/new',
            edit: '/cadastro/exemplo/edit/:id',
            view: '/cadastro/exemplo/edit/:id/view',
        },
    },
    sei: {
        analiseNegocial: {
            title: 'Análise Negocial',
            url: {
                list: '/analise-negocial',
                edit: '/analise-negocial/edit/:id',
            },
        },
        analisePropostaMeta: {
            title: 'Analisar Proposta de Metas',
            url: {
                list: '/analise-proposta-meta',
                edit: '/analise-proposta-meta/edit/:id',
                view: '/analise-proposta-meta/edit/:id/view',
            },
        },
        analiseMetodologica: {
            title: 'Análise Metodológica',
            legenda: 'Lista de análises metodológicas cadastradas',
            url: {
                list: '/analise-metodologica',
                edit: '/analise-metodologica/edit/:id',
            },
        },
        propostaIndicador: {
            title: 'Proposta Indicador',
            legenda: 'Lista com as propostas cadastradas',
            tabs: {
                dadosGerais: 'Dados Gerais',
                dadosComplementares: 'Dados Complementares',
                serieHistorica: 'Série Histórica',
            },
            url: {
                list: '/proposta-indicador',
                new: '/proposta-indicador/new',
                edit: '/proposta-indicador/edit/:id',
                view: '/proposta-indicador/edit/:id/view',
            },
        },
        statusProposta: {
            title: 'Proposta Indicador',
            url: {
                list: '/status-proposta/:id',
            },
        },
        indicador: {
            title: 'Indicador',
            legenda: 'Lista com o indicadores cadastradas',
            tabs: {
                dadosGerais: 'Dados Gerais',
                dadosComplementares: 'Dados Complementares',
                serieHistorica: 'Série Histórica',
            },
            url: {
                list: '/indicador',
                edit: '/indicador/edit/:id',
                view: '/indicador/edit/:id/view',
            },
        },
        indicadorSolicitacoes: {
            title: 'Solicitações de Ativação/Inativação',
            url: {
                list: '/indicador-solicitacoes',
                edit: '/indicador-solicitacoes/edit/:id',
                view: '/indicador-solicitacoes/edit/:id/view',
            },
        },
        historicoIndicador: {
            title: 'Histórico do Indicador',
            tabs: {
                historicoVersoes: 'Histórico de Versões',
                historicoSituacoes: 'Histórico de Situações',
            },
            url: {
                list: '/indicador/:id/historico',
                view: '/indicador/:id/historico/:idProposta/view',
            },
        },
        metasResultados: {
            title: 'Metas e Resultados',
            tabs: {
                metas: 'Metas',
                apuracaoResultado: 'Apuração de Resultado',
                avaliacaoResultado: 'Avaliação de Resultado',
            },
            url: {
                list: '/indicador/:id/metas-resultados',
            },
        },
    },
};

export default Pages;
